import React from 'react';
import { Button } from '../ui/button';

const WelcomeStep = ({ onNext }) => {
  return (
    <div className="text-center flex flex-col items-center justify-center min-h-[60vh]">
      {/* Animated Egg Character */}
      <div className="relative mb-12">
        <div className="absolute inset-0 bg-[#F1B428]/10 rounded-full blur-3xl animate-pulse" />
        <div className="relative w-48 h-64 md:w-56 md:h-72 animate-bounce-slow">
          <svg
            viewBox="0 0 200 280"
            className="w-full h-full drop-shadow-2xl"
          >
            {/* Egg shape */}
            <ellipse
              cx="100"
              cy="160"
              rx="80"
              ry="110"
              fill="url(#eggGradient)"
              className="animate-wiggle"
            />
            {/* Face elements */}
            <ellipse cx="75" cy="140" rx="8" ry="12" fill="#F1B428" />
            <ellipse cx="125" cy="140" rx="8" ry="12" fill="#F1B428" />
            <path
              d="M 70 170 Q 100 185 130 170"
              stroke="#F1B428"
              strokeWidth="4"
              fill="none"
              strokeLinecap="round"
            />
            {/* Decorative stripes */}
            <path
              d="M 50 120 Q 100 130 150 120"
              stroke="#F1B428"
              strokeWidth="12"
              fill="none"
              strokeLinecap="round"
            />
            <path
              d="M 60 200 Q 100 205 140 200"
              stroke="#F1B428"
              strokeWidth="8"
              fill="none"
              strokeLinecap="round"
            />
            <defs>
              <linearGradient id="eggGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#2A2A2A" />
                <stop offset="50%" stopColor="#1A1A1A" />
                <stop offset="100%" stopColor="#0E0E0E" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      <h1 className="text-white text-3xl md:text-4xl font-bold mb-6">
        Welcome to your
        <br />
        AI universe!
      </h1>
      
      <p className="text-white/70 text-base md:text-lg mb-2">
        You have joined
      </p>
      <p className="text-[#F1B428] text-2xl md:text-3xl font-bold mb-12">
        1 459 090 <span className="text-white font-normal">of Butterscotch AI users</span>
        <br />
        <span className="text-white font-normal">worldwide</span>
      </p>

      <Button
        onClick={onNext}
        className="w-full max-w-sm bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30"
      >
        Continue
      </Button>
    </div>
  );
};

export default WelcomeStep;
